export default __webpack_public_path__ + "static/media/Single-Visit.c5633312.png";